module.exports = __webpack_public_path__ + "img/img_size_07.6444b381.png";